import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImageUrl } from "@/lib/api";
import { Stack, Books } from "@phosphor-icons/react";
import Seo from "@/components/Seo";

export default function SeriesIndex() {
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/series").then(r => setSeries(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <div className="pt-20 max-w-6xl mx-auto px-5 lg:px-8 pb-24" data-testid="series-index-page">
      <Seo title="Séries" description="Explora as séries de mangá e acompanha todos os volumes." path="/series" />
      <div className="mb-8">
        <div className="font-mono-accent text-xs text-[#E63946] mb-2 flex items-center gap-1.5"><Stack size={14} weight="bold" /> SÉRIES</div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight">Séries de Mangá</h1>
        <p className="text-zinc-400 mt-2">Acompanha todos os volumes das tuas séries favoritas.</p>
      </div>
      {loading ? (
        <div className="text-center text-zinc-500 py-16 font-mono-accent text-xs">A CARREGAR...</div>
      ) : series.length === 0 ? (
        <div className="border border-dashed border-white/10 rounded-2xl p-16 text-center">
          <Stack size={40} weight="duotone" className="text-zinc-600 mx-auto mb-3" />
          <div className="font-display font-bold text-lg">Ainda sem séries</div>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {series.map(s => (
            <Link key={s.series_id} to={`/serie/${s.slug}`} className="group flex gap-4 bg-[#121217] border border-white/5 rounded-2xl p-4 hover:border-[#E63946]/40 transition-colors" data-testid={`series-card-${s.series_id}`}>
              <div className="w-20 aspect-[2/3] rounded-lg overflow-hidden bg-[#0f0f14] flex-shrink-0">
                {s.image_url ? <img src={resolveImageUrl(s.image_url)} alt={s.name} className="w-full h-full object-cover" /> : <div className="w-full h-full grid place-items-center text-zinc-700"><Books size={22} /></div>}
              </div>
              <div className="min-w-0">
                <div className="font-display font-bold text-lg leading-tight group-hover:text-[#E63946] transition-colors line-clamp-2">{s.name}</div>
                <div className="text-xs text-zinc-500 mt-1">{s.volume_count} volumes</div>
                {s.description && <p className="text-xs text-zinc-400 mt-2 line-clamp-3">{s.description}</p>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
